import type { Role } from '@domain/entities';
import type { IRoleRepository } from '@domain/repositories';

export class ToggleRoleStatusUseCase {
  constructor(private readonly roleRepository: IRoleRepository) {}

  async execute(role: Role): Promise<Role> {
    return role.status === 'ACTIVE'
      ? this.roleRepository.deactivate(role.id)
      : this.roleRepository.activate(role.id);
  }
}
